import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ProjectModel } from '../../../model/project.model';
import { ProjectModelService } from '../../../service/project-model.service';
import { ProjectArticleService } from '../../../service/project-article.service';
import { ProjectMetaElementService } from '../../../manager/project-meta-element.service';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArticleManager } from '@article/manager/article.manager';
import { ProServeArticleManager } from '@article/manager/pro-serve-article.manager';
import { ProjectGroupDataService } from '../service/project-group-data.service';
import { DrillingHoleHelper } from '@3d-scene/model3d/util/drillinghole/drilling-hole.helper';
import { ArticleObject3DManager } from '@article/manager/article-object-3d.manager';
import { ProjectGroupLoadingService } from '../../project/service/project-group-loading.service';
import { TextSizeCheckManager } from '@3d-scene/manager/text-size-check.manager';
import { SaveProjectService } from '../../project/project-save/save-project.service';
import { ArticleExportDataService } from '@article/service/article-export-data.service';
import { ArticleCreationManagerFactory } from '../../article/manager/article-creation.manager.factory';
import { BlockingZoneArticleManagerFactory } from '../../article/manager/blocking-zone-article-manager.factory';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { InsertArticleService } from '../../article/service/insert-article.service';
import { ArticleCreationService } from '../../article/service/article-creation.service';
import { AttachArticleUsageService } from '../../../service/attach-article-usage.service';
import { ProServeProjectImportProcessor } from './pro-serve-project-import.processor';
import { ArticleDataService } from '@article/service/article-data.service';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';
import { ProjectUserModel } from '../../../model/project-user.model';
import { UserModel } from '@user/model/user.model';

@Injectable({providedIn: 'root'})
export class ProServeProjectImportProcessorInitializer {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly alertHelper: AlertHelper,
    private readonly projectModel: ProjectModel,
    private readonly projectModelService: ProjectModelService,
    private readonly projectArticleService: ProjectArticleService,
    private readonly projectMetaElementService: ProjectMetaElementService,
    private readonly localeResourceManager: LocaleResourceManager,
    private readonly articleManager: ArticleManager,
    private readonly proServeArticleManager: ProServeArticleManager,
    private readonly projectGroupDataService: ProjectGroupDataService,
    private readonly drillingHoleHelper: DrillingHoleHelper,
    private readonly articleObject3DManager: ArticleObject3DManager,
    private readonly projectGroupLoadingService: ProjectGroupLoadingService,
    private readonly textSizeCheckManager: TextSizeCheckManager,
    private readonly saveProjectService: SaveProjectService,
    private readonly articleExportDataService: ArticleExportDataService,
    private readonly articleDataService: ArticleDataService,
    private readonly articleCreationManagerFactory: ArticleCreationManagerFactory,
    private readonly blockingZoneArticleManagerFactory: BlockingZoneArticleManagerFactory,
    private readonly connectionInfoService: ConnectionInfoService,
    private readonly containerService: ContainerService,
    private readonly insertArticleService: InsertArticleService,
    private readonly articleCreationService: ArticleCreationService,
    private readonly attachArticleUsageService: AttachArticleUsageService,
    private readonly proServeProjectImportProcessor: ProServeProjectImportProcessor,
    private readonly projectUserModel: ProjectUserModel,
    private readonly userModel: UserModel,
  ) {}

  public initialize() {
    this.proServeProjectImportProcessor.initialize(
      this.alertHelper,
      this.httpClient,
      this.projectModel,
      this.projectModelService,
      this.projectArticleService,
      this.projectMetaElementService,
      this.localeResourceManager,
      this.articleManager,
      this.proServeArticleManager,
      this.projectGroupDataService,
      this.drillingHoleHelper,
      this.articleObject3DManager,
      this.projectGroupLoadingService,
      this.textSizeCheckManager,
      this.saveProjectService,
      this.articleExportDataService,
      this.articleDataService,
      this.articleCreationManagerFactory,
      this.blockingZoneArticleManagerFactory,
      this.connectionInfoService,
      this.containerService,
      this.insertArticleService,
      this.articleCreationService,
      this.attachArticleUsageService,
      this.projectUserModel,
      this.userModel,
    );
  }
}
